export const initialState = {
  loadingStatus: {
    preferredSiteListLoading: false,
  },
  preferredSiteList: [],

  error: '',
};
